import React from 'react'
import styleOverride from './style'
import Icon from './Icon'
import clsx from 'clsx'

const Copy: React.FC<any> = ({ ...props }) => {
  props.className = clsx(styleOverride().root, props.className)
  props.type = props.type || 'outlined'
  props.color = props.color || '#464646'
  return <Icon {...props} />
}

export default Copy
